import React, { useEffect, useState } from 'react';
// import Card from "../../components/elements/Card";
import AdminLayout from '../../components/layout/admin';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import { useMutation, useQuery } from '@tanstack/react-query';
import { showNotification } from '../../utilities/mantineNotification';
import {
  Avatar,
  Flex,
  Image,
  Indicator,
  Popover,
  Tabs,
  Text,
  ThemeIcon,
  Title,
  Card,
  Badge,
  Button,
  Group,
  Grid,
  Container,
  Center,
  TextInput,
  Autocomplete,
  SegmentedControl,
  Stack
} from '@mantine/core';
import * as Unicons from '@iconscout/react-unicons';
import { listEmail, listUser, syncUser } from '../../services/syncUser';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';
import LabelDate from '../../components/fragments/LabelDate';
import DataTables from '../../components/elements/DataTables';
import LoadingIllustration from '../../components/fragments/IllustrationState/LoadingIllustration';
import ModalWrapper from '../../components/elements/ModalWrapper';

const SyncUser = (props) => {
  const [oldEmail, setOldEmail] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [modalAdd, setModalAdd] = useState(false);

  const [prosesSearchOldEmail, setProsesSearchOldEmail] = useState(false);
  const [prosesSearchNewEmail, setProsesSearchNewEmail] = useState(false);

  const [listOldEmail, setListOldEmail] = useState([]);
  const [listNewEmail, setListNewEmail] = useState([]);

  const [modalDialog, setModalDialog] = useState({
    show: false,
    data: null
  });

  const _handleSyncUser = (e: any) => {
    e.preventDefault();
    if (oldEmail === '') {
      showNotification({
        type: 'error',
        message: 'Old Email is required'
      });
      return;
    }
    if (newEmail === '') {
      showNotification({
        type: 'error',
        message: 'New Email is required'
      });
      return;
    }
    // if (!checkIsEmailValid(oldEmail)) {
    //   showNotification({
    //     type: 'error',
    //     message: 'Old Email is not valid'
    //   });
    //   return;
    // }
    // if (!checkIsEmailValid(newEmail)) {
    //   showNotification({
    //     type: 'error',
    //     message: 'New Email is not valid'
    //   });
    //   return;
    // }
    if (oldEmail === newEmail) {
      showNotification({
        type: 'error',
        message: 'Old Email and New Email must be different'
      });
      return;
    }
    setModalDialog({
      show: true,
      data: null
    });
  };

  const handleMutate = () => {
    const partsOld = oldEmail.split(' - ');
    const eOld = partsOld[1];

    const partsNew = oldEmail.split(' - ');
    const eNew = partsOld[1];
    const payload = {
      emailFrom: eOld,
      emailTo: eNew
    };
    console.log(payload);
    // syncEmailUser.mutate(payload);
  };

  const syncEmailUser = useMutation({
    mutationFn: syncUser,
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Success Sync User'
      });
      setModalDialog({
        show: false,
        data: null
      });
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const [timeoutIdOldEmail, setTimeoutIdOldEmail] = useState(null);
  const [timeoutIdNewEmail, setTimeoutIdNewEmail] = useState(null);

  useEffect(() => {
    if (oldEmail !== '' && oldEmail.length > 3) {
      if (timeoutIdOldEmail) {
        clearTimeout(timeoutIdOldEmail);
      }

      const id = setTimeout(() => {
        setProsesSearchOldEmail(true);
        handleSearchOldEmail();
      }, 1000);

      setTimeoutIdOldEmail(id);
    }
  }, [oldEmail]);

  useEffect(() => {
    if (newEmail !== '' && newEmail.length > 3) {
      if (timeoutIdNewEmail) {
        clearTimeout(timeoutIdNewEmail);
      }

      const id = setTimeout(() => {
        setProsesSearchNewEmail(true);
        handleSearchNewEmail();
      }, 1000);

      setTimeoutIdNewEmail(id);
    }
  }, [newEmail]);

  const handleSearchOldEmail = () => {
    const payload = {
      email: oldEmail,
      auth: 'manual'
    };
    listUserOldEmail.mutate(payload);
  };

  const listUserOldEmail = useMutation({
    mutationFn: listEmail,
    onSuccess: (e) => {
      const emails = e?.data?.data.map(
        (item) => item.userid + ' - ' + item.email
      );
      // console.log(emails);
      setListOldEmail(emails);
      setProsesSearchOldEmail(false);
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const handleSearchNewEmail = () => {
    const payload = {
      email: newEmail,
      auth: 'oidc'
    };
    listUserNewEmail.mutate(payload);
  };

  const listUserNewEmail = useMutation({
    mutationFn: listEmail,
    onSuccess: (e) => {
      const emails = e?.data?.data.map(
        (item) => item.userid + ' - ' + item.email
      );
      setListNewEmail(emails);
      setProsesSearchNewEmail(false);
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const columns = [
    {
      heading: 'Old Email',
      props: 'emailFrom',
      id: 'emailFrom',
      sortable: true
    },
    {
      heading: 'New Email',
      props: 'emailTo',
      id: 'emailTo',
      sortable: true
    },
    {
      heading: 'Synchronized By',
      props: 'namaBinusian',
      id: 'namaBinusian',
      sortable: true
    },
    {
      heading: 'Updated At',
      props: (item) => renderDate(item, 'dateIn'),
      id: 'dateIn',
      sortable: true
    }

    // {
    //   heading: 'Action',
    //   props: 'action',
    //   sortable: false
    // }
  ];

  const renderDate = (item, key) => <LabelDate date={item[key]} />;

  const [modalConfig, setModalConfig] = useState({
    show: false,
    data: null,
    type: ''
  });

  const fetchedDataListUser = useQuery({
    queryKey: [`interestUser`, props.auth?.email],
    queryFn: () => listUser(props.auth?.email),
    enabled: true
  });

  const loadingState =
    fetchedDataListUser.isLoading || fetchedDataListUser.isLoading;

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle="Sync User"
        itemList={[
          {
            title: 'BCL&D Back Office',
            href: '#',
            icon: <Unicons.UilFileCopyAlt />
          },
          {
            title: 'Sync User',
            href: 'management/sync-user'
          }
        ]}
      />
      {loadingState && (
        <LoadingIllustration
          description="Please wait... Currently collecting data..."
          title="Preparing Data"
        />
      )}
      {!loadingState && (
        <>
          <Card>
            <Flex
              style={{
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Stack mb={10} gap={'xs'}>
                <Title order={4}>History Sync User</Title>
                <Text size="sm">Below is the list of history sync user.</Text>
              </Stack>
              <>
                <Button
                  color="#7B2183"
                  radius="md"
                  onClick={() => {
                    setModalAdd(true);
                  }}
                >
                  Sync User
                </Button>
              </>
            </Flex>
            <DataTables
              columns={columns}
              loading={false}
              data={fetchedDataListUser.data?.data?.data || []}
            />
          </Card>
        </>
      )}
      <ModalWrapper
        title="Synchronize User"
        isVisible={modalAdd}
        onClose={() => {
          setModalAdd(false);
        }}
        size={'xl'}
      >
        <Group justify="space-between" mt="md" mb="xs">
          <Text fw={500}>
            If you want to synchronize the user then you can use this form, you
            also need to declare the previous email and the next email
          </Text>
        </Group>
        <form onSubmit={_handleSyncUser}>
          <Autocomplete
            label="Old Email"
            placeholder="johndoe@provider.com"
            radius={'md'}
            required
            onChange={(value) => setOldEmail(value)}
            value={oldEmail}
            data={listOldEmail}
          />
          <Autocomplete
            mt={10}
            label="New Email"
            placeholder="linadoe@provider.com"
            radius={'md'}
            required
            onChange={(value) => setNewEmail(value)}
            value={newEmail}
            data={listNewEmail}
          />
          <Button color="#7B2183" fullWidth mt="md" radius="md" type="submit">
            {syncEmailUser.isLoading
              ? 'Loading...'
              : prosesSearchNewEmail || prosesSearchOldEmail
              ? 'Loading...'
              : 'Sync User'}
          </Button>
        </form>
        <ModalConfirmation
          isVisible={modalDialog.show}
          type="Submit Data"
          onCancel={() => {
            setModalDialog({
              show: false,
              data: null
            });
          }}
          onConfirm={() => {
            handleMutate();
          }}
        />
      </ModalWrapper>
    </AdminLayout>
  );
};

function checkIsEmailValid(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export default SyncUser;
